<template>
  <v-dialog v-model="dialogVisible" 
    persistent
    width="90%"
    max-width="360px" 
  >
    <template v-slot:activator="scope">
      <activator-button :scope="scope" />
    </template>

    <v-form @submit.prevent="submitClick">
      <v-card>
        <v-card-text>
          <v-textarea
            auto-grow
            outlined
            v-model="notes"
            label="Notes"
            hide-details="auto"
          ></v-textarea>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="justify-center">
          <v-btn @click="close">Cancel</v-btn>
          <v-btn color="primary" type="submit">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { ActivatorButton } from '@/components/pages'

  export default {
    props: ['lead'],

    components: { ActivatorButton },

    data() {
      return {
        dialogVisible: false,
        
        notes: "",

        error_dialog: true,
        error_message: '',
      }
    },

    watch: {
      dialogVisible(visible) {
        if( visible ) {
          this.notes = this.lead.pro_notes
        }
      },
    },

    methods: {
      ...mapActions('leads', ['updateCurrent']),

      close() {
        this.dialogVisible = false
      },

      async submitClick() {
        const payload = {
          lead_id: this.lead.lead_id,
          pro_notes: this.notes
        }

        let result = await this.updateCurrent(payload)
        if( result.ok ) {
          this.close()
        } else {
          this.error_dialog = true
          this.error_message = result.error
        }
      },
    
    },
  }
</script>

<style scoped>
  .v-dialog__content {
    position: absolute;
  }
</style>